class QuizManager {
  constructor() {
    this.currentQuestionIndex = 0;
    this.questions = this.initializeQuestions();
    this.answers = {};
    this.selectedOptions = [];
    this.initializeStorage();
    this.initializeQuizButtons();
    this.updateProgress();
  }

  initializeStorage() {
    // Initialize storage for specific fields
    if (!localStorage.getItem("quizData")) {
      localStorage.setItem(
        "quizData",
        JSON.stringify({
          height: null,
          weight: null,
          age: null,
        })
      );
    }
  }

  initializeQuizButtons() {
    // Add click handlers to order buttons to start quiz
    const orderButtons = document.querySelectorAll(
      '[id$="-order-btn"], [id$="-order-desktop-btn"]'
    );
    orderButtons.forEach((button) => {
      const originalOnClick = button.onclick;
      button.onclick = null;
      button.addEventListener("click", (e) => {
        e.preventDefault();
        const quizContainer = document.getElementById("quiz-container");
        if (quizContainer) {
          quizContainer.classList.remove("hidden");
          this.renderCurrentQuestion();
        } else {
          console.error("Quiz container not found");
        }
      });
    });

    // Initialize back button
    const backButton = document.getElementById("back-button");
    if (backButton) {
      backButton.addEventListener("click", () => {
        if (this.currentQuestionIndex === 0) {
          const quizContainer = document.getElementById("quiz-container");
          if (quizContainer) {
            quizContainer.classList.add("hidden");
          }
        } else {
          this.handleBackClick();
        }
      });
    } else {
      console.warn("Back button not found");
    }
  }

  initializeQuestions() {
    return [
      {
        type: "multiple",
        title: "What are your goals?",
        description: "PLEASE SELECT ALL THAT APPLY",
        answers: [
          "Losing weight",
          "Keeping body healthy from inside",
          "Improving my gut health",
        ],
      },
      {
        type: "single",
        title: "How often do you eat veggies?",
        description:
          "YOUR VEGGIES CAN BE RAW OR COOKED, AS LONG AS THEY'RE PREPARED IN A HEALTHY WAY",
        answers: [
          "I don't really eat veggies",
          "I eat veggies from time to time",
          "I eat veggies every day",
        ],
      },
      {
        type: "single",
        title: "How often do you eat fermented foods?",
        description: "LIKE YOGURT, SAUERKRAUT, PICKLES, OR MISO",
        answers: ["Never", "Sometimes", "Often", "Every day"],
      },
      {
        type: "single",
        title: "Have you gained weight in the last year?",
        description: "",
        answers: ["Yes", "No"],
      },
      {
        type: "multiple",
        title: "What diets have you tried in the last year?",
        description: "PLEASE SELECT ALL THAT APPLY",
        answers: [
          "Keto",
          "Fasting",
          "Paleo",
          "Mediterranean",
          "DASH diet",
          "Vegetarian / Vegan diet",
          "Other",
          "None",
        ],
      },
      {
        type: "multiple",
        title: "Do you experience any of the following symptoms?",
        description: "PLEASE SELECT ALL THAT APPLY",
        answers: [
          "Indigestion / nausea",
          "Constipation",
          "Brain fog / fatigue",
          "Gas / bloating",
          "Diarrhea",
          "None of the above",
        ],
      },
      {
        type: "multiple",
        title: "Do you struggle with any of the following issues?",
        description: "PLEASE SELECT ALL THAT APPLY",
        answers: [
          "Weight bouncing back",
          "Hunger / cravings",
          "Low energy",
          "None",
        ],
      },
      {
        type: "multiple",
        title: "Do you sometimes tend to...",
        description: "PLEASE SELECT ALL THAT APPLY",
        answers: [
          "Overeat",
          "Stress eat",
          "Eat irregurarly",
          "Eat fast food",
          "None of the above",
        ],
      },
      {
        type: "info",
        title: "We got you!",
        description: "That's definitely something we can help you with.",
        image:
          "https://cdn.shopify.com/s/files/1/0939/1200/6974/files/quiz-info.webp?v=1746832931",
        features: [
          "Probiotic Strains",
          "Prebiotic Fibers",
          "Postbiotic Enzymes",
        ],
        buttonText: "Let's go",
      },
      {
        type: "input",
        title: "How old are you?",
        name: "age",
        description: "",
      },
      {
        type: "height",
        title: "What's your height?",
        description: "",
      },
      {
        type: "weight",
        title: "How much would you like to lose?",
        description: "",
      },
      {
        type: "calculation",
        title: "Calculating your results...",
        image:
          "https://cdn.shopify.com/s/files/1/0939/1200/6974/files/loading-bar_534fe2dd-76d2-4a7e-b0d0-27d2bbde7e24.webp?v=1747318997",
      },
    ];
  }

  updateProgress() {
    const progress =
      ((this.currentQuestionIndex + 1) / this.questions.length) * 100;
    document.getElementById("progress-bar").style.width = `${progress}%`;
    document.getElementById("current-question").textContent =
      this.currentQuestionIndex + 1;
    document.getElementById("total-questions").textContent =
      this.questions.length;
  }

  handleNextClick() {
    if (this.currentQuestionIndex === this.questions.length - 1) {
      this.handleQuizCompletion();
      return;
    }

    this.currentQuestionIndex++;
    this.updateProgress();
    this.renderCurrentQuestion();

    if (window.innerWidth <= 768) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }

  handleBackClick() {
    if (this.currentQuestionIndex === 0) {
      window.location.href = "/";
      return;
    }

    this.currentQuestionIndex--;
    // Clear selected options when going back
    this.selectedOptions = [];
    this.updateProgress();
    this.renderCurrentQuestion();

    if (window.innerWidth <= 768) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }

  saveAnswer(questionIndex, answer) {
    this.answers[questionIndex] = answer;

    // Save specific fields to localStorage
    const currentQuestion = this.questions[questionIndex];
    if (currentQuestion.type === "height") {
      this.saveToStorage("height", answer);
    } else if (currentQuestion.type === "weight") {
      this.saveToStorage("weight", answer);
    } else if (
      currentQuestion.type === "input" &&
      currentQuestion.name === "age"
    ) {
      this.saveToStorage("age", answer);
    }
  }

  saveToStorage(key, value) {
    const quizData = JSON.parse(localStorage.getItem("quizData"));
    quizData[key] = value;
    localStorage.setItem("quizData", JSON.stringify(quizData));
  }

  renderCurrentQuestion() {
    // Clear selected options when rendering any question
    this.selectedOptions = [];

    const question = this.questions[this.currentQuestionIndex];
    const container = document.getElementById("question-container");

    if (!container) {
      console.error("Question container not found");
      return;
    }

    let html = `<div class="question-wrapper animate-fade-in">`;

    // Only add title and description for non-info type questions
    if (question.type !== "info" && question.type !== "calculation") {
      html += `
        <h2 class="question-title">${question.title}</h2>
        ${question.description ? `<p class="question-subtitle">${question.description}</p>` : ""}
      `;
    }

    switch (question.type) {
      case "multiple":
        html += this.renderMultipleChoice(question);
        break;
      case "single":
        html += this.renderSingleChoice(question);
        break;
      case "input":
        html += this.renderInputField(question);
        break;
      case "height":
        html += this.renderHeightInput(question);
        break;
      case "weight":
        html += this.renderWeightInput(question);
        break;
      case "info":
        html = this.renderInfoPage(question);
        break;
      case "calculation":
        html = this.renderCalculationPage(question);
        break;
    }

    if (question.type !== "calculation" && question.type !== "info") {
      html += "</div>";
    }

    container.innerHTML = html;

    // Start calculation animation if needed
    if (question.type === "calculation") {
      this.startCalculationProgress();
    }

    // Hide the fixed-bottom-button if single choice
    if (question.type === "single") {
      const btn = document.querySelector(".fixed-bottom-button");
      if (btn) btn.style.display = "none";
    }
  }

  renderMultipleChoice(question) {
    const options = question.answers.map((answer, index) => {
      const optionId = `option-${this.currentQuestionIndex}-${index}`;
      const isSelected = this.selectedOptions.includes(optionId);
      const svg = isSelected
        ? `<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <rect x="2" y="2" width="20" height="20" rx="10" fill="#5a8a76"/>
            <g clip-path="url(#clip0_1_15)">
              <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM11.7071 16.2779C11.3178 16.6755 10.6789 16.6788 10.2854 16.2853L7.29542 13.2946C6.90581 12.9049 6.90585 12.2732 7.29549 11.8836V11.8836C7.68475 11.4943 8.31572 11.4938 8.70557 11.8825L11 14.17L15.8811 9.15938C16.2707 8.75947 16.9124 8.7564 17.3058 9.15258V9.15258C17.6908 9.54027 17.6929 10.1653 17.3107 10.5556L11.7071 16.2779Z" fill="#e5ecf2"/>
            </g>
            <defs>
              <clipPath id="clip0_1_15">
                <rect width="24" height="24" fill="white"/>
              </clipPath>
            </defs>
          </svg>`
        : `<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <rect x="2" y="2" width="20" height="20" rx="10" fill="#e1eae9"/>
          </svg>`;

      return `
        <div class="option ${isSelected ? "selected" : ""}" 
             onclick="quizManager.toggleMultipleChoice('${optionId}')"
             data-option-id="${optionId}"
             role="button"
             tabindex="0">
          <span>${answer}</span>
          <span>${svg}</span>
        </div>
      `;
    });

    const arrowSVG = `<span class="flex items-center justify-center rounded-full"><svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="12" fill="white" /><g clip-path="url(#a)"><path fill="white" d="M4 4h16v16H4z" /><path fill="#01a76f" d="m14.782 11.333-3.576-3.576.942-.942L17.334 12l-5.186 5.185-.942-.942 3.576-3.576H6.667v-1.334h8.115z" /></g><defs><clipPath id="a"><path transform="translate(4 4)" d="M0 0h16v16H0z" /></clipPath></defs></svg></span>`;

    return `
      <div class="options-wrapper">
        ${options.join("")}
      </div>
      <div class="fixed-bottom-button">
        <button class="quiz-button" onclick="quizManager.handleNextClick()" ${
          this.selectedOptions.length === 0 ? "disabled" : ""
        }>
          <span class="font-[500]">Next</span>${arrowSVG}
        </button>
      </div>
    `;
  }

  renderSingleChoice(question) {
    const options = question.answers.map((answer, index) => {
      const optionId = `option-${this.currentQuestionIndex}-${index}`;
      const isSelected = this.selectedOptions.includes(optionId);
      const arrowSVG = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" class="ml-1 flex-shrink-0">
        <path d="M8 0L6.59 1.41L12.17 7H0V9H12.17L6.59 14.59L8 16L16 8L8 0Z" 
        fill="${isSelected ? "white" : "#121917"}"
        class="transition-colors duration-200 ease-in-out" />
      </svg>`;

      return `
        <div class="option2 ${isSelected ? "selected" : ""}" 
             onclick="quizManager.selectSingleChoice('${optionId}')"
             data-option-id="${optionId}"
             role="button"
             tabindex="0">
          <span class="flex-grow">${answer}</span>
          <span class="flex-shrink-0">${arrowSVG}</span>
        </div>
      `;
    });

    return `
      <div class="options-wrapper">
        ${options.join("")}
      </div>
    `;
  }

  //  ### AGE INPUT STEP ###

  renderInputField(question) {
    const arrowSVG = `<span class="flex items-center justify-center rounded-full"><svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="12" fill="white" /><g clip-path="url(#a)"><path fill="white" d="M4 4h16v16H4z" /><path fill="#01a76f" d="m14.782 11.333-3.576-3.576.942-.942L17.334 12l-5.186 5.185-.942-.942 3.576-3.576H6.667v-1.334h8.115z" /></g><defs><clipPath id="a"><path transform="translate(4 4)" d="M0 0h16v16H0z" /></clipPath></defs></svg></span>`;

    return `
      <div class="question-wrapper animate-fade-in mt-2">        
        <div class="mx-auto md:max-w-md sm:max-w-sm w-full px-4">
          <div class="relative flex flex-col">
            <input 
              type="text" 
              id="age-input" 
              name="age" 
              class="block px-2.5 pb-2.5 pt-5 w-full text-[16px] text-gray-900 bg-white border border-gray-200 rounded-md appearance-none focus:outline-none focus:ring-0 peer" 
              placeholder=" " 
              oninput="quizManager.checkAgeInput()"
              required
            />
            <label 
              for="age-input" 
              class="absolute text-sm left-2.5 text-gray-500 duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] peer-focus:text-black peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4"
            >
              Age
            </label>
            <p class="error-message text-red-300 text-sm mt-3 text-center w-full" id="age-error"></p>
          </div>
        </div>

        <div class="fixed bottom-0 left-0 w-full bg-white py-4 px-4 flex justify-center items-center md:static md:py-6 md:bg-transparent md:shadow-none">
          <button 
            class="quiz-button flex items-center justify-center gap-3 md:mx-auto" 
            onclick="quizManager.handleAgeSubmit()" 
            disabled
          >
            <span class="font-[500]">Next</span>${arrowSVG}
          </button>
        </div>
      </div>
    `;
  }

  checkAgeInput() {
    const ageInput = document.getElementById("age-input");
    const nextButton = document.querySelector(".quiz-button");
    // Simply enable the button if any input is present
    nextButton.disabled = !ageInput.value;
    // Clear any existing error when user starts typing again
    document.getElementById("age-error").textContent = "";
  }

  validateAge() {
    const ageInput = document.getElementById("age-input");
    const ageError = document.getElementById("age-error");

    if (!ageInput.value) {
      ageError.textContent = "Please enter your age";
      return false;
    }

    const age = parseInt(ageInput.value);

    if (age < 18) {
      ageError.textContent = "Please enter an age over 18!";
      return false;
    } else if (age > 120) {
      ageError.textContent =
        "Please enter a valid age. Age cannot exceed 120 years";
      return false;
    }

    return true;
  }

  handleAgeSubmit() {
    if (!this.validateAge()) {
      return;
    }

    const age = document.getElementById("age-input").value;
    this.saveAnswer(this.currentQuestionIndex, parseInt(age));
    this.handleNextClick();
  }

  //  == HEIGHT INPUT STEP ==
  renderHeightInput() {
    const arrowSVG = `<span class="flex items-center justify-center rounded-full"><svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="12" fill="white" /><g clip-path="url(#a)"><path fill="white" d="M4 4h16v16H4z" /><path fill="#01a76f" d="m14.782 11.333-3.576-3.576.942-.942L17.334 12l-5.186 5.185-.942-.942 3.576-3.576H6.667v-1.334h8.115z" /></g><defs><clipPath id="a"><path transform="translate(4 4)" d="M0 0h16v16H0z" /></clipPath></defs></svg></span>`;

    return `
      <div class="question-wrapper animate-fade-in">
        <div class="mx-auto md:max-w-md sm:max-w-sm w-full px-4 mb-5">
          <div class="bg-[#efefff] text-black w-full flex flex-row justify-center mx-auto py-1 px-1 rounded-md gap-x-2 cursor-pointer">
            <div
              class="flex items-center justify-center py-3 rounded-md flex-1 transition-colors duration-200 ease-in-out"
              style="background-color: white;"
              data-unit="imperial"
              onclick="quizManager.toggleHeightUnit(this)"
            >
              <p class="font-[500] text-sm">Imperial</p>
            </div>
            <div
              class="flex items-center justify-center py-3 rounded-md flex-1 transition-colors duration-200 ease-in-out"
              data-unit="metric"
              onclick="quizManager.toggleHeightUnit(this)"
            >
              <p class="font-[500] text-sm">Metric</p>
            </div>
          </div>
        </div>

        <div class="mx-auto md:max-w-md sm:max-w-sm w-full px-4">
          <div id="imperial-inputs" class="flex gap-2 my-5">
            <div class="relative flex-1">
              <input type="text" 
                     id="feet" 
                     name="feet" 
                     class="block px-2.5 pb-2.5 pt-5 w-full text-[16px] text-gray-900 bg-gray-50 border border-gray-200 rounded-md appearance-none focus:outline-none focus:ring-0 peer" 
                     placeholder=" "
                     oninput="quizManager.checkHeightInputs()"
                     required />
              <label 
                for="feet" 
                class="absolute text-sm left-2.5 text-gray-500 duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] peer-focus:text-black peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4"
              >
                Feet
              </label>
            </div>
            <div class="relative flex-1">
              <input type="text" 
                     id="inches" 
                     name="inches" 
                     class="block px-2.5 pb-2.5 pt-5 w-full text-[16px] text-gray-900 bg-gray-50 border border-gray-200 rounded-md appearance-none focus:outline-none focus:ring-0 peer" 
                     placeholder=" "
                     oninput="quizManager.checkHeightInputs()"
                     required />
              <label 
                for="inches" 
                class="absolute text-sm left-2.5 text-gray-500 duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] peer-focus:text-black peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4"
              >
                Inches
              </label>
            </div>
          </div>

          <div id="metric-inputs" class="my-5" style="display: none;">
            <div class="relative w-full">
              <input type="text" 
                     id="cm" 
                     name="cm" 
                     class="block px-2.5 pb-2.5 pt-5 w-full text-[16px] text-gray-900 bg-gray-50 border border-gray-200 rounded-md appearance-none focus:outline-none focus:ring-0 peer" 
                     placeholder=" "
                     oninput="quizManager.checkHeightInputs()"
                     required />
              <label 
                for="cm" 
                class="absolute text-sm left-2.5 text-gray-500 duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] peer-focus:text-black peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4"
              >
                Height (cm)
              </label>
            </div>
          </div>

          <p class="error-message text-red-300 text-sm mt-2 text-center w-full" id="height-error"></p>
        </div>

        <div class="fixed bottom-0 left-0 w-full bg-white py-4 px-4 flex justify-center items-center md:static md:py-6 md:bg-transparent md:shadow-none">
          <button 
            class="quiz-button flex items-center justify-center gap-3 md:mx-auto" 
            onclick="quizManager.handleHeightSubmit()" 
            disabled
          >
            <span class="font-[500]">Next</span>${arrowSVG}
          </button>
        </div>
      </div>
    `;
  }

  toggleHeightUnit(element) {
    const imperialInputs = document.getElementById("imperial-inputs");
    const metricInputs = document.getElementById("metric-inputs");
    const allOptions = document.querySelectorAll("[data-unit]");

    allOptions.forEach((opt) => {
      if (opt.dataset.unit === element.dataset.unit) {
        opt.style.backgroundColor = "white";
      } else {
        opt.style.backgroundColor = "";
      }
    });

    if (element.dataset.unit === "imperial") {
      imperialInputs.style.display = "flex";
      metricInputs.style.display = "none";
    } else {
      imperialInputs.style.display = "none";
      metricInputs.style.display = "block";
    }

    this.checkHeightInputs();
    document.getElementById("height-error").textContent = "";
  }

  checkHeightInputs() {
    const nextButton = document.querySelector(".quiz-button");
    const activeUnit = document.querySelector(
      "[data-unit][style*='background-color: white']"
    ).dataset.unit;

    // Clear any existing error when user starts typing again
    document.getElementById("height-error").textContent = "";

    if (activeUnit === "imperial") {
      const feet = document.getElementById("feet").value.replace(/\D/g, "");
      const inches = document.getElementById("inches").value.replace(/\D/g, "");
      // Enable button if there's any input in both fields
      nextButton.disabled = !feet || !inches;
    } else {
      const cm = document.getElementById("cm").value.replace(/\D/g, "");
      // Enable button if there's any input
      nextButton.disabled = !cm;
    }
  }

  validateHeight() {
    const heightError = document.getElementById("height-error");
    const activeUnit = document.querySelector(
      "[data-unit][style*='background-color: white']"
    ).dataset.unit;

    if (activeUnit === "imperial") {
      const feet = document.getElementById("feet").value.replace(/\D/g, "");
      const inches = document.getElementById("inches").value.replace(/\D/g, "");

      if (!feet || !inches) {
        heightError.textContent = "Please fill in both fields";
        return false;
      }

      const totalInches = parseInt(feet) * 12 + parseInt(inches);
      if (totalInches < 48) {
        // 4 feet = 48 inches
        heightError.textContent =
          "In order for the results to be accurate, minimum height has to be at least 4 feet";
        return false;
      } else if (parseInt(inches) >= 12) {
        heightError.textContent = "Inches must be less than 12";
        return false;
      }
    } else {
      const cm = document.getElementById("cm").value.replace(/\D/g, "");

      if (!cm) {
        heightError.textContent = "Please enter your height";
        return false;
      }

      if (parseInt(cm) < 150) {
        heightError.textContent =
          "In order for the results to be accurate, minimum height has to be at least 150cm";
        return false;
      }
    }

    return true;
  }

  handleHeightSubmit() {
    // Only validate when user clicks submit
    if (!this.validateHeight()) {
      return;
    }

    const activeUnit = document.querySelector(
      "[data-unit][style*='background-color: white']"
    ).dataset.unit;

    if (activeUnit === "imperial") {
      const feet = parseInt(
        document.getElementById("feet").value.replace(/\D/g, "") || "0"
      );
      const inches = parseInt(
        document.getElementById("inches").value.replace(/\D/g, "") || "0"
      );

      this.saveAnswer(this.currentQuestionIndex, {
        value: feet * 12 + inches,
        unit: "imperial",
      });
    } else {
      const cm = parseInt(
        document.getElementById("cm").value.replace(/\D/g, "") || "0"
      );

      this.saveAnswer(this.currentQuestionIndex, {
        value: cm,
        unit: "metric",
      });
    }

    this.handleNextClick();
  }

  renderWeightInput() {
    const arrowSVG = `<span class="flex items-center justify-center rounded-full"><svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="12" fill="white" /><g clip-path="url(#a)"><path fill="white" d="M4 4h16v16H4z" /><path fill="#01a76f" d="m14.782 11.333-3.576-3.576.942-.942L17.334 12l-5.186 5.185-.942-.942 3.576-3.576H6.667v-1.334h8.115z" /></g><defs><clipPath id="a"><path transform="translate(4 4)" d="M0 0h16v16H0z" /></clipPath></defs></svg></span>`;

    return `
      <div class="question-wrapper animate-fade-in">
        <div class="mx-auto md:max-w-md sm:max-w-sm w-full px-4 mb-5">
          <div class="bg-[#efefff] text-black w-full flex flex-row justify-center mx-auto py-1 px-1 rounded-md gap-x-2 cursor-pointer">
            <div
              class="flex items-center justify-center py-3 rounded-md flex-1 transition-colors duration-200 ease-in-out"
              style="background-color: white;"
              data-unit="imperial"
              onclick="quizManager.toggleWeightUnit(this)"
            >
              <p class="font-[500] text-sm">Imperial</p>
            </div>
            <div
              class="flex items-center justify-center py-3 rounded-md flex-1 transition-colors duration-200 ease-in-out"
              data-unit="metric"
              onclick="quizManager.toggleWeightUnit(this)"
            >
              <p class="font-[500] text-sm">Metric</p>
            </div>
          </div>
        </div>

        <div class="mx-auto md:max-w-md sm:max-w-sm w-full px-4">
          <div id="imperial-inputs">
            <p class="text-white text-sm font-medium mb-2 text-center">CURRENT WEIGHT</p>
            <div class="relative mb-6">
              <input type="text" 
                     id="pounds" 
                     name="pounds" 
                     class="block px-2.5 pb-2.5 pt-5 w-full text-[16px] text-gray-900 bg-gray-50 border border-gray-200 rounded-md appearance-none focus:outline-none focus:ring-0 peer" 
                     placeholder=" "
                     oninput="quizManager.checkWeightInputs()"
                     required />
              <label 
                for="pounds" 
                class="absolute text-sm left-2.5 text-gray-500 duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] peer-focus:text-black peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4"
              >
                Weight (lb)
              </label>
            </div>

            <p class="text-white text-sm font-medium mb-2 text-center">GOAL WEIGHT</p>
            <div class="relative">
              <input type="text" 
                     id="pounds-goal" 
                     name="pounds-goal" 
                     class="block px-2.5 pb-2.5 pt-5 w-full text-[16px] text-gray-900 bg-gray-50 border border-gray-200 rounded-md appearance-none focus:outline-none focus:ring-0 peer" 
                     placeholder=" "
                     oninput="quizManager.checkWeightInputs()"
                     required />
              <label 
                for="pounds-goal" 
                class="absolute text-sm left-2.5 text-gray-500 duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] peer-focus:text-black peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4"
              >
                Weight (lb)
              </label>
            </div>
          </div>

          <div id="metric-inputs" style="display: none;">
            <p class="text-white text-sm font-medium mb-2 text-center">CURRENT WEIGHT</p>
            <div class="relative mb-6">
              <input type="text" 
                     id="kg" 
                     name="kg" 
                     class="block px-2.5 pb-2.5 pt-5 w-full text-[16px] text-gray-900 bg-gray-50 border border-gray-200 rounded-md appearance-none focus:outline-none focus:ring-0 peer" 
                     placeholder=" "
                     oninput="quizManager.checkWeightInputs()"
                     required />
              <label 
                for="kg" 
                class="absolute text-sm left-2.5 text-gray-500 duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] peer-focus:text-black peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4"
              >
                Weight (kg)
              </label>
            </div>

            <p class="text-white text-sm font-medium mb-2 text-center">GOAL WEIGHT</p>
            <div class="relative">
              <input type="text" 
                     id="kg-goal" 
                     name="kg-goal" 
                     class="block px-2.5 pb-2.5 pt-5 w-full text-[16px] text-gray-900 bg-gray-50 border border-gray-200 rounded-md appearance-none focus:outline-none focus:ring-0 peer" 
                     placeholder=" "
                     oninput="quizManager.checkWeightInputs()"
                     required />
              <label 
                for="kg-goal" 
                class="absolute text-sm left-2.5 text-gray-500 duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] peer-focus:text-black peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4"
              >
                Weight (kg)
              </label>
            </div>
          </div>

          <p class="error-message text-red-300 text-sm mt-2 text-center w-full" id="weight-error"></p>
        </div>

        <div class="fixed bottom-0 left-0 w-full bg-white py-4 px-4 flex justify-center items-center md:static md:py-6 md:bg-transparent md:shadow-none">
          <button 
            class="quiz-button flex items-center justify-center gap-3 md:mx-auto" 
            onclick="quizManager.handleWeightSubmit()" 
            disabled
          >
            <span class="font-[500]">Next</span>${arrowSVG}
          </button>
        </div>
      </div>
    `;
  }

  toggleWeightUnit(element) {
    const imperialInputs = document.getElementById("imperial-inputs");
    const metricInputs = document.getElementById("metric-inputs");
    const allOptions = document.querySelectorAll("[data-unit]");

    allOptions.forEach((opt) => {
      if (opt.dataset.unit === element.dataset.unit) {
        opt.style.backgroundColor = "white";
      } else {
        opt.style.backgroundColor = "";
      }
    });

    if (element.dataset.unit === "imperial") {
      imperialInputs.style.display = "block";
      metricInputs.style.display = "none";
    } else {
      imperialInputs.style.display = "none";
      metricInputs.style.display = "block";
    }

    this.checkWeightInputs();
    document.getElementById("weight-error").textContent = "";
  }

  checkWeightInputs() {
    const nextButton = document.querySelector(".quiz-button");
    const activeUnit = document.querySelector(
      "[data-unit][style*='background-color: white']"
    ).dataset.unit;

    // Clear any existing error when user starts typing again
    document.getElementById("weight-error").textContent = "";

    if (activeUnit === "imperial") {
      const pounds = document.getElementById("pounds").value.replace(/\D/g, "");
      const poundsGoal = document
        .getElementById("pounds-goal")
        .value.replace(/\D/g, "");

      // Enable button if there's any input in both fields
      nextButton.disabled = !pounds || !poundsGoal;
    } else {
      const kg = document.getElementById("kg").value.replace(/\D/g, "");
      const kgGoal = document
        .getElementById("kg-goal")
        .value.replace(/\D/g, "");

      // Enable button if there's any input in both fields
      nextButton.disabled = !kg || !kgGoal;
    }
  }

  validateWeight() {
    const weightError = document.getElementById("weight-error");
    const activeUnit = document.querySelector(
      "[data-unit][style*='background-color: white']"
    ).dataset.unit;

    if (activeUnit === "imperial") {
      const pounds = document.getElementById("pounds").value.replace(/\D/g, "");
      const poundsGoal = document
        .getElementById("pounds-goal")
        .value.replace(/\D/g, "");

      if (!pounds || !poundsGoal) {
        weightError.textContent = "Please fill in both weight fields";
        return false;
      }

      const currentWeight = parseInt(pounds);
      const goalWeight = parseInt(poundsGoal);

      if (currentWeight < 100) {
        weightError.textContent =
          "In order for the results to be accurate, minimum weight has to be at least 100 pounds";
        return false;
      } else if (goalWeight >= currentWeight) {
        weightError.textContent =
          "Goal weight must be less than your current weight";
        return false;
      }
    } else {
      const kg = document.getElementById("kg").value.replace(/\D/g, "");
      const kgGoal = document
        .getElementById("kg-goal")
        .value.replace(/\D/g, "");

      if (!kg || !kgGoal) {
        weightError.textContent = "Please fill in both weight fields";
        return false;
      }

      const currentWeight = parseInt(kg);
      const goalWeight = parseInt(kgGoal);

      if (currentWeight < 40) {
        weightError.textContent =
          "In order for the results to be accurate, minimum weight has to be at least 40 kg";
        return false;
      } else if (goalWeight >= currentWeight) {
        weightError.textContent =
          "Goal weight must be less than your current weight";
        return false;
      }
    }

    return true;
  }

  handleWeightSubmit() {
    // Only validate when user clicks submit
    if (!this.validateWeight()) {
      return;
    }

    const activeUnit = document.querySelector(
      "[data-unit][style*='background-color: white']"
    ).dataset.unit;
    let currentWeight, goalWeight;

    if (activeUnit === "imperial") {
      currentWeight = parseInt(
        document.getElementById("pounds").value.replace(/\D/g, "") || "0"
      );
      goalWeight = parseInt(
        document.getElementById("pounds-goal").value.replace(/\D/g, "") || "0"
      );
    } else {
      currentWeight = parseInt(
        document.getElementById("kg").value.replace(/\D/g, "") || "0"
      );
      goalWeight = parseInt(
        document.getElementById("kg-goal").value.replace(/\D/g, "") || "0"
      );
    }

    this.saveAnswer(this.currentQuestionIndex, {
      currentWeight: currentWeight,
      goalWeight: goalWeight,
      unit: activeUnit,
    });

    this.handleNextClick();
  }

  renderInfoPage(question) {
    return `
      <div class="w-[100vw]">
        <div class="animate-fade-in w-full mx-auto justify-center items-center flex flex-row gap-x-15 md:gap-y-10 gap-y-2 flex-wrap-reverse mt-6 md:mt-28 mb-10 pb-[5rem] md:pb-0">
          <div class="sm:w-5/6 md:w-2/6 mx-10">
            <div class="text-white font-[500]">
              <p class="mb-4 text-3xl font-semibold md:mb-10 md:text-5xl ">${question.title}</p>
              <p class="mb-2 text-md md:mb-5 md:text-base">${question.description}</p>
              <p class="mb-2 text-sm md:mb-6 md:text-base">With Bala you get natural ingredients to help you lose weight:</p>
              ${question.features
                .map(
                  (feature) => `
                <p class="flex flex-row items-center mb-2 text-smxr md:mb-2 gap-x-3 md:text-base">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-check size-4">
                    <path d="M20 6 9 17l-5-5"></path>
                  </svg>
                  ${feature}
                </p>
              `
                )
                .join("")}
              <p class="text-sm md:text-base">Let's begin with a few more questions about your eating habits.</p>
            </div>
            <div class="fixed bottom-0 left-0 w-full bg-white py-4 px-4 flex justify-center items-center">
              <button type="button" onclick="quizManager.handleNextClick()" class="flex justify-center items-center  h-14 text-[1.05rem] rounded-md gap-2 duration-200 transition-all text-white border border-[#01a76f] bg-[#01a76f] md:hover:bg-[#01a76f]/80 md:hover:border-[#4aa75e]/80 cursor-pointer border-none shadow-md w-full md:w-[500px]">
                <span class="font-[500]">${question.buttonText || "Let's go"}</span>
                <span class="flex items-center justify-center w-6 h-6 rounded-full">
                  <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="12" fill="white"></circle>
                    <g clip-path="url(#a)">
                      <path fill="white" d="M4 4h16v16H4z"></path>
                      <path fill="#01a76f" d="m14.782 11.333-3.576-3.576.942-.942L17.334 12l-5.186 5.185-.942-.942 3.576-3.576H6.667v-1.334h8.115z"></path>
                    </g>
                    <defs>
                      <clipPath id="a">
                        <path transform="translate(4 4)" d="M0 0h16v16H0z"></path>
                      </clipPath>
                    </defs>
                  </svg>
                </span>
              </button>
            </div>
          </div>
          <div class="animate-[fadeIn_1s_ease-in-out] relative w-[1200px] md:w-[500px] h-[300px] md:h-[400px]">
            <img 
              src="${question.image}" 
              alt="product" 
              fetchpriority="high"
              loading="eager"
              decoding="async"
              class="object-contain animate-[fadeIn_1s_ease-in-out]"
              style="position: absolute; height: 100%; width: 100%; inset: 0px; color: transparent;"
            />
          </div>
        </div>
      </div>
    `;
  }

  renderCalculationPage(question) {
    return `
      <div class="flex flex-col items-center justify-center relative mt-auto md:mt-20 animate-[fadeIn_1s_ease-in-out]">
        <div class="relative w-full h-48 md:h-64 flex items-center justify-center mb-6">
          <img src="${question.image}" alt="Calculating" class="object-contain mx-auto w-full h-full animate-pulse">
        </div>
        
        <div class="progress-bar w-11/12 md:w-96 h-2 rounded-full mx-auto bg-white/60">
          <div id="calculation-progress-fill" class="progress-fill h-2 rounded-full bg-white/60" style="width: 0%; transition: width 0.3s ease-in-out;"></div>
        </div>
        
        <div class="progress-text text-white mt-8">
          <p id="calc-text-1" class="flex flex-row items-center gap-x-3 mb-4 calc-text text-white" style="opacity: 0; transition: 0.3s ease-in-out;">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM9.003 14L16.073 6.929L14.659 5.515L9.003 11.172L6.174 8.343L4.76 9.757L9.003 14Z" fill="white"></path>
            </svg>
            Evaluating your answers...
          </p>
          
          <p id="calc-text-2" class="flex flex-row items-center gap-x-3 mb-4 calc-text text-white" style="opacity: 0; transition: 0.3s ease-in-out;">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM9.003 14L16.073 6.929L14.659 5.515L9.003 11.172L6.174 8.343L4.76 9.757L9.003 14Z" fill="white"></path>
            </svg>
            Analyzing your results...
          </p>
          
          <p id="calc-text-3" class="flex flex-row items-center gap-x-3 mb-4 calc-text text-white" style="opacity: 0; transition: 0.3s ease-in-out;">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM9.003 14L16.073 6.929L14.659 5.515L9.003 11.172L6.174 8.343L4.76 9.757L9.003 14Z" fill="white"></path>
            </svg>
            Determining your gut type...
          </p>
          
          <p id="calc-text-4" class="flex flex-row items-center gap-x-3 mb-4 calc-text text-white" style="opacity: 0; transition: 0.3s ease-in-out;">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM9.003 14L16.073 6.929L14.659 5.515L9.003 11.172L6.174 8.343L4.76 9.757L9.003 14Z" fill="white"></path>
            </svg>
            Building your summary...
          </p>
        </div>
      </div>
    `;
  }

  // After rendering the calculation page, start the progress animation
  startCalculationProgress() {
    let progress = 0;
    const progressFill = document.getElementById("calculation-progress-fill");
    const calcText1 = document.getElementById("calc-text-1");
    const calcText2 = document.getElementById("calc-text-2");
    const calcText3 = document.getElementById("calc-text-3");
    const calcText4 = document.getElementById("calc-text-4");

    if (!progressFill || !calcText1 || !calcText2 || !calcText3 || !calcText4) {
      console.warn("Calculation progress elements not found");
      return;
    }

    const interval = setInterval(() => {
      progress += 1;

      // Update progress bar
      progressFill.style.width = `${progress}%`;

      // Show text at specific progress points
      if (progress === 25) {
        calcText1.style.opacity = 1;
      }

      if (progress === 50) {
        calcText2.style.opacity = 1;
      }

      if (progress === 75) {
        calcText3.style.opacity = 1;
      }

      if (progress === 100) {
        calcText4.style.opacity = 1;
        clearInterval(interval);

        // Trigger next action after a delay
        setTimeout(() => {
          this.handleQuizCompletion();
        }, 1000);
      }
    }, 60); // 60ms per tick for smooth animation
  }

  toggleMultipleChoice(optionId) {
    const option = document.querySelector(`[data-option-id="${optionId}"]`);
    if (!option) return;

    // Check if this is a "None" option that should deselect others
    const isNoneOption =
      option.textContent.trim() === "None" ||
      option.textContent.trim() === "None of the above";

    // Add visual feedback for selection
    option.classList.add("selecting");

    const index = this.selectedOptions.indexOf(optionId);
    const isSelected = index === -1;

    // Use setTimeout to create a slight delay for better visual feedback
    setTimeout(() => {
      if (isSelected) {
        // If selecting a "None" option, deselect all other options
        if (isNoneOption) {
          // First remove selected class from all options
          const allOptions = document.querySelectorAll(
            `[data-option-id^="option-${this.currentQuestionIndex}-"]`
          );
          allOptions.forEach((opt) => {
            opt.classList.remove("selected");
            // Update SVG to unselected state
            this.updateOptionSvg(opt, false);
            const optId = opt.getAttribute("data-option-id");
            const optIndex = this.selectedOptions.indexOf(optId);
            if (optIndex !== -1) {
              this.selectedOptions.splice(optIndex, 1);
            }
          });

          // Then select only this option
          this.selectedOptions = [optionId];
          option.classList.add("selected");
          // Update SVG to selected state
          this.updateOptionSvg(option, true);
        } else {
          // If selecting a regular option, deselect "None" if it's selected
          const noneOption = Array.from(
            document.querySelectorAll(
              `[data-option-id^="option-${this.currentQuestionIndex}-"]`
            )
          ).find(
            (opt) =>
              opt.textContent.trim() === "None" ||
              opt.textContent.trim() === "None of the above"
          );

          if (noneOption && noneOption.classList.contains("selected")) {
            noneOption.classList.remove("selected");
            // Update SVG to unselected state
            this.updateOptionSvg(noneOption, false);
            const noneOptId = noneOption.getAttribute("data-option-id");
            const noneIndex = this.selectedOptions.indexOf(noneOptId);
            if (noneIndex !== -1) {
              this.selectedOptions.splice(noneIndex, 1);
            }
          }

          // Add this option
          this.selectedOptions.push(optionId);
          option.classList.add("selected");
          // Update SVG to selected state
          this.updateOptionSvg(option, true);
        }
      } else {
        // Remove this option
        this.selectedOptions.splice(index, 1);
        option.classList.remove("selected");
        // Update SVG to unselected state
        this.updateOptionSvg(option, false);
      }

      this.saveAnswer(this.currentQuestionIndex, this.selectedOptions);

      // Update button state
      const nextButton = document.querySelector(".quiz-button");
      if (nextButton) {
        nextButton.disabled = this.selectedOptions.length === 0;
      }

      option.classList.remove("selecting");
    }, 50);
  }

  // Add a helper method to update the SVG content based on selection state
  updateOptionSvg(optionElement, isSelected) {
    const svgContainer = optionElement.querySelector("span:last-child");
    if (!svgContainer) return;

    const svg = isSelected
      ? `<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <rect x="2" y="2" width="20" height="20" rx="10" fill="#111917"/>
          <g clip-path="url(#clip0_1_15)">
            <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM11.7071 16.2779C11.3178 16.6755 10.6789 16.6788 10.2854 16.2853L7.29542 13.2946C6.90581 12.9049 6.90585 12.2732 7.29549 11.8836V11.8836C7.68475 11.4943 8.31572 11.4938 8.70557 11.8825L11 14.17L15.8811 9.15938C16.2707 8.75947 16.9124 8.7564 17.3058 9.15258V9.15258C17.6908 9.54027 17.6929 10.1653 17.3107 10.5556L11.7071 16.2779Z" fill="white"/>
          </g>
          <defs>
            <clipPath id="clip0_1_15">
              <rect width="24" height="24" fill="#334140"/>
            </clipPath>
          </defs>
        </svg>`
      : `<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <rect x="2" y="2" width="20" height="20" rx="10" fill="#879492"/>
        </svg>`;

    svgContainer.innerHTML = svg;
  }

  selectSingleChoice(optionId) {
    const options = document.querySelectorAll(
      `[data-option-id^="option-${this.currentQuestionIndex}-"]`
    );

    const selectedOption = document.querySelector(
      `[data-option-id="${optionId}"]`
    );

    if (!selectedOption) return;

    // Add selecting class for immediate visual feedback
    selectedOption.classList.add("selecting");

    // Remove selected class from all options
    options.forEach((opt) => opt.classList.remove("selected"));

    // Add selected class to the clicked option
    selectedOption.classList.add("selected");

    // Save the selected option
    this.selectedOptions = [optionId];
    this.saveAnswer(this.currentQuestionIndex, optionId);

    // Use setTimeout to create a slight delay before moving to next question
    // This gives users time to see their selection
    setTimeout(() => {
      selectedOption.classList.remove("selecting");

      // Wait a bit longer for next question to improve user experience
      // but only on non-touch devices since mobile needs faster response
      const isMobile = window.matchMedia("(max-width: 768px)").matches;

      setTimeout(
        () => {
          this.handleNextClick();
        },
        isMobile ? 300 : 100
      );
    }, 50);
  }

  handleQuizCompletion() {
    window.location.href = "/pages/weight-loss-email";
  }
}

// Initialize quiz manager when the DOM is fully loaded
document.addEventListener("DOMContentLoaded", function () {
  try {
    console.log("Initializing quiz manager...");

    // Make sure quiz container exists before initializing
    const quizContainer = document.getElementById("quiz-container");
    if (!quizContainer) {
      console.warn("Quiz container element not found. Adding it dynamically.");

      // Create quiz container if it doesn't exist
      const quizHtml = `
        <div id="quiz-container" class="fixed inset-0 bg-quad-gradient overflow-auto hidden z-50">
          <div class="relative min-h-screen w-full max-w-5xl mx-auto flex flex-col">
            <!-- Quiz Header -->
            <div class="py-4 px-6 flex justify-between items-center">
              <button id="back-button" class="text-black font-medium flex items-center gap-1">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15.41 7.41L14 6L8 12L14 18L15.41 16.59L10.83 12L15.41 7.41Z" fill="currentColor"/>
                </svg>
                Back
              </button>
              <div class="flex items-center gap-1 text-black text-sm">
                Question <span id="current-question">1</span> of <span id="total-questions">13</span>
              </div>
            </div>
            
            <!-- Progress Bar -->
            <div class="w-full bg-gray-200 h-1">
              <div id="progress-bar" class="bg-[#42785f] h-full transition-all duration-300" style="width: 0%"></div>
            </div>
            
            <!-- Question Container -->
            <div id="question-container" class="flex-grow px-6 py-8"></div>
          </div>
        </div>
      `;

      // Append to body
      document.body.insertAdjacentHTML("beforeend", quizHtml);
    }

    // Initialize quiz manager
    window.quizManager = new QuizManager();

    // Add event listeners to input fields to only allow numeric input
    document.addEventListener("input", function (e) {
      const numericInputs = [
        "age-input",
        "feet",
        "inches",
        "cm",
        "pounds",
        "pounds-goal",
        "kg",
        "kg-goal",
      ];
      if (numericInputs.includes(e.target.id)) {
        e.target.value = e.target.value.replace(/\D/g, "");
      }
    });

    console.log("Quiz manager initialized successfully");
  } catch (error) {
    console.error("Error initializing quiz manager:", error);
  }
});

// Add this CSS to your stylesheet or in a style tag
document.head.insertAdjacentHTML(
  "beforeend",
  `
  <style>
    .quiz-button {
      @apply cursor-pointer border-none shadow-md w-full md:w-[500px] bg-[#7ebf90] text-white font-[500] px-6 py-3 rounded-full transition-all duration-200 transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100;
    }
  </style>
`
);

// Add this CSS to your stylesheet or update existing styles
document.head.insertAdjacentHTML(
  "beforeend",
  `
  <style>
    .option2 {
      @apply flex items-center justify-between w-full px-6 py-4 mb-3 text-black bg-white rounded-lg cursor-pointer transition-colors duration-200;
    }
    .option2:hover {
      @apply bg-[#7ebf90] text-white;
    }
    .option2.selected {
      @apply bg-[#7ebf90] text-white;
    }
    .option2:hover svg path {
      fill: white;
    }
  </style>
`
);
